import axios from 'axios'
import queryString from 'query-string'
import { TransactionsFiltersBody } from 'src/components/TransactionsListFilter/transactionsFilter.schema'
import { ExtendCurrency } from 'src/enums'
import { getResponseData } from 'src/queries/network.utils'
import { getRequestConfig, RequestConfig } from 'src/queries/requestConfig'

export interface AccountingStatistics {
  usdTotalCardSpendCents?: number
  cadTotalCardSpendCents?: number
  currencies: ExtendCurrency[]
  pendingManagerReview: number
  pendingFinalApproval: number
  missingReceipts: number
  missingCategories: number
  notSyncedToErp: number
}

export interface AccountingStatisticsResponse {
  statisticsData: AccountingStatistics
}

export const getAccountingStatistics = async (
  filters?: Partial<TransactionsFiltersBody>,
): Promise<AccountingStatisticsResponse> =>
  getResponseData(
    axios.get<AccountingStatisticsResponse>(
      `reports/transactions/v2/accounting/stats?${queryString.stringify({ ...filters })}`,
      getRequestConfig(RequestConfig.Default),
    ),
  )
